export default "__VITE_ASSET__G9mpR$3T__"